// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Package show (Stitch: Full Height / Cardiology consult) ——— */
.pkg-show {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 24px;
  background: #F8FAFC;
}

.pkg-show__shell {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pkg-show__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pkg-show__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.pkg-show__crumb {
  color: #64748B;
  text-decoration: none;
  transition: color 0.12s ease;
}

.pkg-show__crumb:hover {
  color: #0EA5E9;
}

.pkg-show__crumb--muted {
  color: #94A3B8;
}

.pkg-show__crumb--current {
  color: #0F172A;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
}

.pkg-show__breadcrumb .lucide {
  color: #CBD5E1;
  flex-shrink: 0;
}

[dir='rtl'] .pkg-show__breadcrumb .lucide,
[dir='rtl'] .pkg-show__back .lucide,
[dir='rtl'] .pkg-show__view-all .lucide,
[dir='rtl'] .pkg-show__record-link .lucide {
  transform: scaleX(-1);
}

/* Hero card */
.pkg-show__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.pkg-show__hero-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.pkg-show__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: none;
  border-radius: 8px;
  background: #F1F5F9;
  color: #334155;
  cursor: pointer;
  flex-shrink: 0;
}

.pkg-show__back:hover {
  background: #E2E8F0;
  color: #0F172A;
}

.pkg-show__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.pkg-show__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.pkg-show__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
  max-width: 42rem;
}

.pkg-show__code {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: #F1F5F9;
  color: #475569;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.pkg-show__code--inline {
  background: #F1F5F9;
  color: #0F172A;
}

.pkg-show__hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pkg-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.pkg-show__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pkg-show__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.pkg-show__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
}

.pkg-show__btn--ghost .lucide {
  color: #64748B;
}

.pkg-show__btn--ghost-primary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #0EA5E9;
  font-weight: 600;
  height: 32px;
  padding: 0 12px;
}

.pkg-show__btn--ghost-primary:hover {
  background: #F0F9FF;
  border-color: #BAE6FD;
}

.pkg-show__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
}

.pkg-show__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

/* Status */
.pkg-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1.4;
}

.pkg-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pkg-show__status.is-active {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.pkg-show__status.is-active .pkg-show__status-dot {
  background: #10B981;
}

.pkg-show__status.is-pending {
  background: #F0F9FF;
  color: #0284C7;
  border-color: #BAE6FD;
}

.pkg-show__status.is-pending .pkg-show__status-dot {
  background: #0EA5E9;
}

.pkg-show__status.is-settled {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.pkg-show__status.is-settled .pkg-show__status-dot {
  background: #10B981;
}

.pkg-show__status.is-inactive {
  background: #F1F5F9;
  color: #475569;
  border-color: #E2E8F0;
}

.pkg-show__status.is-inactive .pkg-show__status-dot {
  background: #94A3B8;
}

/* Bento */
.pkg-show__bento {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 1100px) {
  .pkg-show__bento {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
  }
}

.pkg-show__card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  min-width: 0;
}

.pkg-show__card-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
}

.pkg-show__card-banner--soft {
  border-color: transparent;
  background: rgba(248, 250, 252, 0.8);
}

.pkg-show__card-banner-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.pkg-show__card-banner-title .lucide {
  color: #0EA5E9;
}

.pkg-show__card-banner-meta {
  font-size: 11px;
  font-weight: 500;
  color: #64748B;
}

.pkg-show__quarter {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
}

.pkg-show__specs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px 24px;
}

@media (min-width: 640px) {
  .pkg-show__specs-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.pkg-show__field {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pkg-show__field--wide {
  grid-column: 1 / -1;
}

.pkg-show__field-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8;
}

.pkg-show__field-value {
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
}

.pkg-show__field-value--icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pkg-show__entity-icon {
  display: inline-flex;
  color: #0EA5E9;
}

.pkg-show__entity-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: 8px;
  background: #F8FAFC;
  border: 1px solid #F1F5F9;
}

.pkg-show__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.pkg-show__entity-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.pkg-show__entity-name {
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pkg-show__entity-sub {
  font-size: 11px;
  color: #64748B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pkg-show__availability {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #0F172A;
}

.pkg-show__availability-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pkg-show__availability-dot.is-on {
  background: #10B981;
}

.pkg-show__availability-dot.is-off {
  background: #94A3B8;
}

.pkg-show__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  font-weight: 500;
  color: #0F172A;
}

.pkg-show__mono--muted {
  color: #64748B;
}

.pkg-show__mono--strong {
  font-weight: 600;
}

.pkg-show__submono {
  display: block;
  margin-top: 2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #64748B;
}

/* Utilization metrics */
.pkg-show__metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pkg-show__metric {
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
}

.pkg-show__metric-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.pkg-show__metric-value {
  margin-top: 2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 20px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.2;
}

.pkg-show__metric-value.is-primary {
  color: #0EA5E9;
}

.pkg-show__metric-value.is-success {
  color: #059669;
}

.pkg-show__metric-unit {
  font-family: inherit;
  font-size: 12px;
  font-weight: 400;
  color: #64748B;
}

.pkg-show__spectrum {
  padding: 12px;
  border-radius: 8px;
  background: #F8FAFC;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pkg-show__spectrum--empty {
  font-size: 12px;
  color: #64748B;
}

.pkg-show__spectrum-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.pkg-show__spectrum-bar {
  display: flex;
  width: 100%;
  height: 8px;
  border-radius: 9999px;
  overflow: hidden;
  background: #E2E8F0;
}

.pkg-show__spectrum-seg {
  display: block;
  height: 100%;
}

.pkg-show__spectrum-seg.is-low {
  background: #BAE6FD;
}

.pkg-show__spectrum-seg.is-mid {
  background: #38BDF8;
}

.pkg-show__spectrum-seg.is-high {
  background: #0284C7;
}

.pkg-show__spectrum-legend {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #64748B;
}

.pkg-show__util-foot {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
  font-size: 12px;
  color: #64748B;
}

/* Shared section shells for tables */
.pkg-show__tiers,
.pkg-show__recent {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.pkg-show__tiers-head,
.pkg-show__recent-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 20px;
  background: rgba(248, 250, 252, 0.5);
  border-bottom: 1px solid #E2E8F0;
}

.pkg-show__tiers-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.pkg-show__tiers-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.pkg-show__tiers-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.pkg-show__tiers-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0369A1;
  font-size: 11px;
  font-weight: 600;
}

.pkg-show__live-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
}

.pkg-show__view-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.pkg-show__view-all:hover {
  color: #0284C7;
}

.pkg-show__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 24px;
  color: #64748B;
  font-size: 13px;
  text-align: center;
}

.pkg-show__empty p {
  margin: 0;
}

.pkg-show__table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.pkg-show__table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
}

.pkg-show__table thead th {
  padding: 10px 16px;
  border-bottom: 1px solid #E2E8F0;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #F8FAFC;
  white-space: nowrap;
}

.pkg-show__table thead th.is-action {
  text-align: end;
}

.pkg-show__table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #F1F5F9;
  font-size: 13px;
  color: #0F172A;
  vertical-align: middle;
}

.pkg-show__table tbody tr:last-child td {
  border-bottom: none;
}

.pkg-show__table tbody tr:hover {
  background: #F8FAFC;
}

.pkg-show__table tbody tr.is-muted td {
  color: #64748B;
}

.pkg-show__table tbody tr.is-muted .pkg-show__price {
  color: #64748B;
  font-weight: 500;
}

.pkg-show__table tbody td.is-action {
  text-align: end;
}

.pkg-show__tier-cell {
  min-width: 0;
}

.pkg-show__tier-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pkg-show__tier-name {
  font-weight: 600;
  color: #0F172A;
}

.pkg-show__tier-inline {
  font-size: 12px;
  font-weight: 500;
  color: #0F172A;
}

.pkg-show__chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.pkg-show__chip.is-default {
  background: #E0F2FE;
  color: #0284C7;
}

.pkg-show__chip.is-promo {
  background: #ECFDF5;
  color: #059669;
}

.pkg-show__chip.is-vip {
  background: #FEF3C7;
  color: #D97706;
}

.pkg-show__price {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  font-size: 13px;
  color: #0F172A;
}

.pkg-show__price.is-offer {
  color: #059669;
}

.pkg-show__patient-name {
  display: block;
  font-weight: 500;
  color: #0F172A;
}

.pkg-show__table-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease;
}

.pkg-show__table-btn:hover {
  background: #F8FAFC;
  border-color: #BAE6FD;
}

.pkg-show__record-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.pkg-show__record-link:hover {
  background: #F8FAFC;
}

.pkg-show__tiers-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.pkg-show__tiers-note {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #64748B;
  max-width: 40rem;
}

.pkg-show__tiers-note .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
  margin-top: 1px;
}

.pkg-show__tiers-total {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}

.pkg-show__pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.pkg-show__pager--between {
  justify-content: space-between;
}

.pkg-show__pager-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pkg-show__pager-btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.pkg-show__pager-btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.pkg-show__pager-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pkg-show__pager-page {
  font-size: 12px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

/* Legacy drawer helpers */
.transaction-drawer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.transaction-drawer .ant-drawer-content-wrapper {
  width: 1100px !important;
  height: 642px !important;
}

.add-submit-button {
  width: 100%;
  padding: 12px 152px 3.5px 116px !important;
  border-radius: 6px !important;
  background-color: var(--primary-color) !important;
  border-color: white !important;
}

.package-print {
  display: none;
}

@media print {
  .clinical-main__scroll:has(.package-print) .pkg-show {
    display: none !important;
  }

  .package-print {
    display: block !important;
    box-sizing: border-box;
    width: 100%;
    color: #0f172a;
    background: #ffffff;
    font-size: 10pt;
    line-height: 1.4;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .package-print * {
    box-shadow: none !important;
  }

  .package-print__header {
    margin: 0 0 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e2e8f0;
    page-break-after: avoid;
  }

  .package-print__kicker {
    margin: 0;
    font-size: 8pt;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94a3b8;
  }

  .package-print__header h1 {
    margin: 2px 0 0;
    font-size: 18pt;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: #0f172a;
  }

  .package-print__meta {
    margin: 2px 0 0;
    font-size: 9pt;
    color: #64748b;
  }

  .package-print__section {
    display: block;
    margin: 0 0 16px;
  }

  .package-print__section > h2 {
    margin: 0 0 8px;
    font-size: 16pt;
    font-weight: 700;
    line-height: 1.2;
    color: #0f172a;
    border-bottom: 2px solid #0f172a;
    padding-bottom: 4px;
    page-break-after: avoid;
  }

  .package-print__empty {
    margin: 0;
    color: #64748b;
  }

  .package-print table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }

  .package-print thead {
    display: table-header-group;
  }

  .package-print tr {
    page-break-inside: avoid;
  }

  .package-print th,
  .package-print td {
    padding: 5px 8px;
    border-bottom: 1px solid #e2e8f0;
    text-align: start;
    vertical-align: top;
  }

  .package-print thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 8pt;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .package-print td {
    color: #334155;
    font-size: 9.5pt;
  }

  .package-print__facts th {
    width: 18%;
    background: transparent;
    color: #64748b;
    font-size: 8pt;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .package-print__facts td {
    width: 32%;
    color: #0f172a;
    font-weight: 600;
    white-space: pre-wrap;
  }
}

@media (max-width: 768px) {
  .pkg-show {
    padding: 16px;
  }

  .pkg-show__title {
    font-size: 20px;
  }

  .pkg-show__hero,
  .pkg-show__card {
    padding: 16px;
  }

  .pkg-show__tiers-head,
  .pkg-show__recent-head {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowPackage/style.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,6BAA6B;EAC7B,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ——— Package show (Stitch: Full Height / Cardiology consult) ——— */\n.pkg-show {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 24px;\n  background: #F8FAFC;\n}\n\n.pkg-show__shell {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.pkg-show__topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pkg-show__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.pkg-show__crumb {\n  color: #64748B;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.pkg-show__crumb:hover {\n  color: #0EA5E9;\n}\n\n.pkg-show__crumb--muted {\n  color: #94A3B8;\n}\n\n.pkg-show__crumb--current {\n  color: #0F172A;\n  text-transform: none;\n  letter-spacing: 0;\n  font-size: 12px;\n}\n\n.pkg-show__breadcrumb .lucide {\n  color: #CBD5E1;\n  flex-shrink: 0;\n}\n\n[dir='rtl'] .pkg-show__breadcrumb .lucide,\n[dir='rtl'] .pkg-show__back .lucide,\n[dir='rtl'] .pkg-show__view-all .lucide,\n[dir='rtl'] .pkg-show__record-link .lucide {\n  transform: scaleX(-1);\n}\n\n/* Hero card */\n.pkg-show__hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.pkg-show__hero-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n}\n\n.pkg-show__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border: none;\n  border-radius: 8px;\n  background: #F1F5F9;\n  color: #334155;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pkg-show__back:hover {\n  background: #E2E8F0;\n  color: #0F172A;\n}\n\n.pkg-show__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pkg-show__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.pkg-show__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n  max-width: 42rem;\n}\n\n.pkg-show__code {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #475569;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.pkg-show__code--inline {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.pkg-show__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pkg-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.pkg-show__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pkg-show__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.pkg-show__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.pkg-show__btn--ghost .lucide {\n  color: #64748B;\n}\n\n.pkg-show__btn--ghost-primary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #0EA5E9;\n  font-weight: 600;\n  height: 32px;\n  padding: 0 12px;\n}\n\n.pkg-show__btn--ghost-primary:hover {\n  background: #F0F9FF;\n  border-color: #BAE6FD;\n}\n\n.pkg-show__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.pkg-show__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n/* Status */\n.pkg-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.pkg-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pkg-show__status.is-active {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.pkg-show__status.is-active .pkg-show__status-dot {\n  background: #10B981;\n}\n\n.pkg-show__status.is-pending {\n  background: #F0F9FF;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.pkg-show__status.is-pending .pkg-show__status-dot {\n  background: #0EA5E9;\n}\n\n.pkg-show__status.is-settled {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.pkg-show__status.is-settled .pkg-show__status-dot {\n  background: #10B981;\n}\n\n.pkg-show__status.is-inactive {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #E2E8F0;\n}\n\n.pkg-show__status.is-inactive .pkg-show__status-dot {\n  background: #94A3B8;\n}\n\n/* Bento */\n.pkg-show__bento {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n@media (min-width: 1100px) {\n  .pkg-show__bento {\n    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);\n  }\n}\n\n.pkg-show__card {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  min-width: 0;\n}\n\n.pkg-show__card-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n}\n\n.pkg-show__card-banner--soft {\n  border-color: transparent;\n  background: rgba(248, 250, 252, 0.8);\n}\n\n.pkg-show__card-banner-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pkg-show__card-banner-title .lucide {\n  color: #0EA5E9;\n}\n\n.pkg-show__card-banner-meta {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pkg-show__quarter {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pkg-show__specs-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px 24px;\n}\n\n@media (min-width: 640px) {\n  .pkg-show__specs-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.pkg-show__field {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pkg-show__field--wide {\n  grid-column: 1 / -1;\n}\n\n.pkg-show__field-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.pkg-show__field-value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pkg-show__field-value--icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pkg-show__entity-icon {\n  display: inline-flex;\n  color: #0EA5E9;\n}\n\n.pkg-show__entity-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  border: 1px solid #F1F5F9;\n}\n\n.pkg-show__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.pkg-show__entity-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.pkg-show__entity-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pkg-show__entity-sub {\n  font-size: 11px;\n  color: #64748B;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pkg-show__availability {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #0F172A;\n}\n\n.pkg-show__availability-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pkg-show__availability-dot.is-on {\n  background: #10B981;\n}\n\n.pkg-show__availability-dot.is-off {\n  background: #94A3B8;\n}\n\n.pkg-show__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pkg-show__mono--muted {\n  color: #64748B;\n}\n\n.pkg-show__mono--strong {\n  font-weight: 600;\n}\n\n.pkg-show__submono {\n  display: block;\n  margin-top: 2px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* Utilization metrics */\n.pkg-show__metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.pkg-show__metric {\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n}\n\n.pkg-show__metric-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.pkg-show__metric-value {\n  margin-top: 2px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.2;\n}\n\n.pkg-show__metric-value.is-primary {\n  color: #0EA5E9;\n}\n\n.pkg-show__metric-value.is-success {\n  color: #059669;\n}\n\n.pkg-show__metric-unit {\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748B;\n}\n\n.pkg-show__spectrum {\n  padding: 12px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pkg-show__spectrum--empty {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pkg-show__spectrum-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pkg-show__spectrum-bar {\n  display: flex;\n  width: 100%;\n  height: 8px;\n  border-radius: 9999px;\n  overflow: hidden;\n  background: #E2E8F0;\n}\n\n.pkg-show__spectrum-seg {\n  display: block;\n  height: 100%;\n}\n\n.pkg-show__spectrum-seg.is-low {\n  background: #BAE6FD;\n}\n\n.pkg-show__spectrum-seg.is-mid {\n  background: #38BDF8;\n}\n\n.pkg-show__spectrum-seg.is-high {\n  background: #0284C7;\n}\n\n.pkg-show__spectrum-legend {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.pkg-show__util-foot {\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n  font-size: 12px;\n  color: #64748B;\n}\n\n/* Shared section shells for tables */\n.pkg-show__tiers,\n.pkg-show__recent {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n}\n\n.pkg-show__tiers-head,\n.pkg-show__recent-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 20px;\n  background: rgba(248, 250, 252, 0.5);\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.pkg-show__tiers-title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.pkg-show__tiers-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pkg-show__tiers-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.pkg-show__tiers-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0369A1;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pkg-show__live-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pkg-show__view-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.pkg-show__view-all:hover {\n  color: #0284C7;\n}\n\n.pkg-show__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 40px 24px;\n  color: #64748B;\n  font-size: 13px;\n  text-align: center;\n}\n\n.pkg-show__empty p {\n  margin: 0;\n}\n\n.pkg-show__table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.pkg-show__table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: start;\n}\n\n.pkg-show__table thead th {\n  padding: 10px 16px;\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: #F8FAFC;\n  white-space: nowrap;\n}\n\n.pkg-show__table thead th.is-action {\n  text-align: end;\n}\n\n.pkg-show__table tbody td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #F1F5F9;\n  font-size: 13px;\n  color: #0F172A;\n  vertical-align: middle;\n}\n\n.pkg-show__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.pkg-show__table tbody tr:hover {\n  background: #F8FAFC;\n}\n\n.pkg-show__table tbody tr.is-muted td {\n  color: #64748B;\n}\n\n.pkg-show__table tbody tr.is-muted .pkg-show__price {\n  color: #64748B;\n  font-weight: 500;\n}\n\n.pkg-show__table tbody td.is-action {\n  text-align: end;\n}\n\n.pkg-show__tier-cell {\n  min-width: 0;\n}\n\n.pkg-show__tier-name-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pkg-show__tier-name {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pkg-show__tier-inline {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pkg-show__chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.pkg-show__chip.is-default {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.pkg-show__chip.is-promo {\n  background: #ECFDF5;\n  color: #059669;\n}\n\n.pkg-show__chip.is-vip {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.pkg-show__price {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  font-size: 13px;\n  color: #0F172A;\n}\n\n.pkg-show__price.is-offer {\n  color: #059669;\n}\n\n.pkg-show__patient-name {\n  display: block;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pkg-show__table-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.pkg-show__table-btn:hover {\n  background: #F8FAFC;\n  border-color: #BAE6FD;\n}\n\n.pkg-show__record-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.pkg-show__record-link:hover {\n  background: #F8FAFC;\n}\n\n.pkg-show__tiers-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.pkg-show__tiers-note {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  color: #64748B;\n  max-width: 40rem;\n}\n\n.pkg-show__tiers-note .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pkg-show__tiers-total {\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  white-space: nowrap;\n}\n\n.pkg-show__pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.pkg-show__pager--between {\n  justify-content: space-between;\n}\n\n.pkg-show__pager-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pkg-show__pager-btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.pkg-show__pager-btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.pkg-show__pager-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pkg-show__pager-page {\n  font-size: 12px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Legacy drawer helpers */\n.transaction-drawer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transaction-drawer .ant-drawer-content-wrapper {\n  width: 1100px !important;\n  height: 642px !important;\n}\n\n.add-submit-button {\n  width: 100%;\n  padding: 12px 152px 3.5px 116px !important;\n  border-radius: 6px !important;\n  background-color: var(--primary-color) !important;\n  border-color: white !important;\n}\n\n.package-print {\n  display: none;\n}\n\n@media print {\n  .clinical-main__scroll:has(.package-print) .pkg-show {\n    display: none !important;\n  }\n\n  .package-print {\n    display: block !important;\n    box-sizing: border-box;\n    width: 100%;\n    color: #0f172a;\n    background: #ffffff;\n    font-size: 10pt;\n    line-height: 1.4;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .package-print * {\n    box-shadow: none !important;\n  }\n\n  .package-print__header {\n    margin: 0 0 14px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e2e8f0;\n    page-break-after: avoid;\n  }\n\n  .package-print__kicker {\n    margin: 0;\n    font-size: 8pt;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #94a3b8;\n  }\n\n  .package-print__header h1 {\n    margin: 2px 0 0;\n    font-size: 18pt;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n    color: #0f172a;\n  }\n\n  .package-print__meta {\n    margin: 2px 0 0;\n    font-size: 9pt;\n    color: #64748b;\n  }\n\n  .package-print__section {\n    display: block;\n    margin: 0 0 16px;\n  }\n\n  .package-print__section > h2 {\n    margin: 0 0 8px;\n    font-size: 16pt;\n    font-weight: 700;\n    line-height: 1.2;\n    color: #0f172a;\n    border-bottom: 2px solid #0f172a;\n    padding-bottom: 4px;\n    page-break-after: avoid;\n  }\n\n  .package-print__empty {\n    margin: 0;\n    color: #64748b;\n  }\n\n  .package-print table {\n    width: 100%;\n    border-collapse: collapse;\n    page-break-inside: auto;\n  }\n\n  .package-print thead {\n    display: table-header-group;\n  }\n\n  .package-print tr {\n    page-break-inside: avoid;\n  }\n\n  .package-print th,\n  .package-print td {\n    padding: 5px 8px;\n    border-bottom: 1px solid #e2e8f0;\n    text-align: start;\n    vertical-align: top;\n  }\n\n  .package-print thead th {\n    background: #f8fafc;\n    color: #64748b;\n    font-size: 8pt;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .package-print td {\n    color: #334155;\n    font-size: 9.5pt;\n  }\n\n  .package-print__facts th {\n    width: 18%;\n    background: transparent;\n    color: #64748b;\n    font-size: 8pt;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  .package-print__facts td {\n    width: 32%;\n    color: #0f172a;\n    font-weight: 600;\n    white-space: pre-wrap;\n  }\n}\n\n@media (max-width: 768px) {\n  .pkg-show {\n    padding: 16px;\n  }\n\n  .pkg-show__title {\n    font-size: 20px;\n  }\n\n  .pkg-show__hero,\n  .pkg-show__card {\n    padding: 16px;\n  }\n\n  .pkg-show__tiers-head,\n  .pkg-show__recent-head {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
